














































import {Vue, Component, Prop} from 'vue-property-decorator';
import ColumnItem from '@/components/common/grid/ColumnItem.vue';
import {ncpPopup} from '@/utils/ncp';

@Component({
  components: {ColumnItem}
})
export default class ReportLayer extends Vue {
  @Prop() private showFlg!: boolean;
  @Prop() private reviewNo!: number;
  private closePop() {
    this.$emit('update:showFlg', false);
  }

  @Prop() private items!: any;
  private showItems: any = [];

  private openReportDetail(reportNo: number) {
    ncpPopup(`/review/report/${reportNo}?reviewNo=${this.reviewNo}`, 'reportDetailPopup');
  }

  private async created() {
    this.showItems = this.items.map((item: any) => {
      let registerName = item.register.memberId || item.register.memberNo;
      if (item.register.memberStatus === 'EXPELLED') {
        registerName = this.$t('PRODUCT_REVIEW_WITHDRAWAL_MEMBER');
      }
      return {
        reportNo: item.reportNo,
        reportDatetime: item.reportDatetime,
        reportReason: item.reportReason,
        content: item.content,
        registerName
      };
    });
  }
}
